import {UserOutlined} from '@ant-design/icons';
import {Avatar} from 'antd';
import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {Link} from 'react-router-dom';

import Email from '@/components/Email';
import Phones from '@/components/PhoneNumberField/PhonesListView';
import ProposalList from '@/modules/admin/components/UserCell/ProposalList';
import UserStatus from '@/modules/admin/components/UserStatus';
import {getFromSource} from '@/utils/getImages';
import {getUserFullName} from '@/utils/userFullName';

import {ROUTE_PATH_OFFICERS_USER, ROUTE_PATH_USER} from '../../contants/users';

const UserCell = ({user, path = ROUTE_PATH_USER}) => {

  return (
    <Link to={`${path}/${user?._id}`}>
      <div className={'flex flex-row'}>
        <div className={'flex lg:items-center mr-2 lg:mr-2 min-w-8'}>
          <Avatar src={getFromSource(user?.avatar)} icon={<UserOutlined/>}/>
        </div>
        <div className={'flex flex-col justify-center truncate'}>
          <div className="flex flex-col md:flex-row md:items-center">
            <span className={'font-medium lg:font-normal text-lg lg:text-base text-primary'}>
              {getUserFullName(user, user?.fullName)}
            </span>
          </div>
          <ProposalList user={user}/>
          <span className={'lg:hidden'}><Email item={user}>{user?.email}</Email></span>
          {user?.phone && <span className={'lg:hidden'}><Phones value={user?.phone}/></span>}
          <span className={'md:hidden mt-2'}><UserStatus status={user?.status}/></span>
        </div>
      </div>
    </Link>
  );
};

UserCell.propTypes = {
  user: PropTypes.object,
  path: PropTypes.string,
};

export default memo(UserCell);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Email component in a table cell
 * @param {String} text this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {Object} user this is the row instance
 * */
export const renderUser = (text, user) => {
  return (
    <UserCell user={user}/>
  );
};

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Email component in a table cell
 * @param {String} text this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {Object} user this is the row instance
 * */
export const renderFunctionary = (text, user) => {
  return (
    <UserCell user={user} path={ROUTE_PATH_OFFICERS_USER}/>
  );
};
